<template lang="html">
  <footer>
    <div class="columns">
      <div class="column">
        <div class="container-address">
        <div class="title-cam">Cámara de Comercio de Montería</div>
        <span>NIT: 891080019</span>
        <span>Calle 28 No. 4 - 61 (Córdoba) Colombia</span>
        <span>PBX: <a class="link" href="tel:0347819292">(574) 781 9292</a> - FAX: <a class="link" href="tel:0347824158">(574) 782 4158</a></span>
        <span><a class="link" href="mailto:contacto@ccmonteria.org.co">contacto@ccmonteria.org.co</a></span>
      </div>
      </div>
      <div class="column">
        <div class="attention-public">
        <span class="title-cam">Horario de atención al público</span><br>
        <span>Lunes a viernes de 8:00 am. a 12:00 pm. y de 2:00 pm. a 6:00 pm.</span><br>
        <span>Los días sabados no son hábiles.</span>
      </div>
      </div>
      <div class="column">
        <div class="container-social">
        <span class="title-cam">Síguenos en</span>
        <div class="social">
          <a class="icon facebook" title="Cámara de Comercio de Montería en Facebook" target="_blank" href="https://www.facebook.com/ccmonteria/"></a>
          <a class="icon youtube" title="Cámara de Comercio de Montería en Youtube" target="_blank" href="https://www.youtube.com/channel/UC7xtfB8M3em-jTLLNl8zjyA"></a>
          <a class="icon instagram" title="Cámara de Comercio de Montería en Instagram" target="_blank" href="https://www.instagram.com/ccmonteria/"></a>
        </div>
      </div>
      </div>
    </div>    
  </footer>

</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
  .dev
    text-align: center
    color: #147fd1
    font-size: 14px
  footer
    & .column
      background: radial-gradient(circle farthest-corner at 200px 0, #00518f, #2196F3)
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
      animation: 1s fade-in-card ease
      img
        width: 60px
    a
      background: radial-gradient(circle farthest-corner at 200px 0, #00518f, #2196F3)
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
</style>



// WEBPACK FOOTER //
// resources/js/components/BaseFooter.vue